module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "usualNewReturn"
    }
  }, [_c('el-col', [_c('div', {
    staticClass: "form-item-flex fl",
    staticStyle: {
      "width": "50%",
      "margin-top": "-62px",
      "margin-left": "330px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30%",
      "margin-right": "20px"
    },
    attrs: {
      "clearable": "",
      "autofocus": true,
      "placeholder": "请输入或扫描序列号"
    },
    on: {
      "input": _vm.inputSerialComform
    },
    model: {
      value: (_vm.returnForm.number),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "number", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "returnForm.number"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.addSerialComformBtn
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('div', {
    staticClass: "totalDiv",
    staticStyle: {
      "position": "absolute",
      "right": "40px",
      "top": "60px"
    }
  }, [_c('small', [_vm._v("数量：")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.returnData.length))]), _vm._v("     \n\t\t\t\t\t"), (_vm.returnForm.returnType == 2) ? _c('span', [_c('small', [_vm._v("总计：")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.totalMoney))]), _vm._v(" 元\n\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "position": "absolute",
      "top": "20px",
      "right": "20px",
      "font-size": "25px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      },
      "default-sort": {
        prop: 'index',
        order: 'descending'
      }
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "row-click": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "code",
      "width": "100",
      "label": "序列号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "200",
      "label": "品牌品类型号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t   \t" + _vm._s(scope.row.brandName) + " " + _vm._s(scope.row.categoryName) + " " + _vm._s(scope.row.modelName) + "\n\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "width": "150",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "orderNo",
      "width": "100",
      "label": "关联订单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "maintainPrice",
      "width": "100",
      "label": "维修金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "warehouseType",
      "width": "100",
      "label": "仓库类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("sysCodeFileter")(scope.row.warehouseType, 'warehouse_type')) + "\n\t\t\t\t\t")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "width": "150",
      "label": "领用时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.pickTime) ? _c('span', [_vm._v(_vm._s(_vm._f("date")(scope.row.pickTime)))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "engineerName",
      "width": "100",
      "label": "退料人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "width": "100",
      "label": "客户自留"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          model: {
            value: (scope.row.isRetenRetain),
            callback: function($$v) {
              _vm.$set(scope.row, "isRetenRetain", $$v)
            },
            expression: "scope.row.isRetenRetain"
          }
        }, _vm._l((_vm.pickingMatain), function(item, index) {
          return _c('el-option', {
            key: index,
            attrs: {
              "label": item.paraName,
              "value": item.paraValue
            }
          })
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteRow(scope.$index, _vm.returnData)
            }
          }
        }, [_vm._v("移除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.DetermineSave()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.DetermineSave2()
      }
    }
  }, [_vm._v("暂存")]), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.DetermineSave1()
      }
    }
  }, [_vm._v("良品入废品")]), _vm._v(" "), _c('el-dropdown', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "split-button": "",
      "type": "primary",
      "trigger": "click"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.pageStatus) + "\n\t\t\t\t"), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.goOnSave()
      }
    }
  }, [_vm._v("留在当前页面")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeSave()
      }
    }
  }, [_vm._v("离开当前页面")])], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelOrder()
      }
    }
  }, [_vm._v("取消新建")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-45a5c2cd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/returnManage/usualNewReturn.vue
// module id = 1655
// module chunks = 0